import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { PermsApiResponse } from './types.tsx';

const URL = '/gateway/api/permissions/permitted';

export const hasConfluenceAccess = async (cloudId: string): Promise<boolean> => {
	try {
		return fetchConfluenceAccess(cloudId);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'hasConfluenceAccess',
				packageName: 'jiraCrossJoinThirdPartyNudges',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw new Error('Confluence permission check error');
	}
};

const fetchConfluenceAccess = async (cloudId: string): Promise<boolean> => {
	const data = {
		permissionId: 'write',
		resourceId: `ari:cloud:confluence::site/${cloudId}`,
	};
	const response = await fetchJson<PermsApiResponse>(URL, {
		method: 'POST',
		body: JSON.stringify(data),
	});
	return response.permitted;
};
